var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[(!this.$apollo.loading)?_c('cpnReferralItens',{attrs:{"referrals":_vm.referral_itens}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }